import { useEffect } from "react";

import * as billPaymentAction from "store/entities/billPayment/action";

import SearchBox from "components/__new/common/SearchBox";
import Table from "components/__new/common/Table";
import { renderStatusColor } from "utils/statusColor";
import Filter from "components/__new/common/Filter";
import { ReactComponent as IconAdd } from "assets/images/icons/project-icons/Plus.svg"
import { TableContent } from "components/__new/common/TableContent";
import { DateFormat, TimeFormat } from "utils/dateFormat";
import CurrencyFormat from "utils/currencyFormat";
import Pagination from "components/__new/common/pagination";
import Maybe from "components/__new/common/Maybe";
import ContentLoading from "components/__new/common/ContentLoading";
import { useState } from "react";
import TableEmptyData from "components/__new/common/TableEmptyData";
import pluralize from "utils/pluralize";
import useBillPayments from "hooks/useBillPayments";
import TransactionDetailsWrapper from "components/__new/common/TransactionDetailsWrapper";
import { useDispatch, useSelector } from "react-redux";
import { useTransformedBillers } from "hooks/useTransformedBillers";

export const AirtimeTransactionsTable = ({togglePurchaseModal, loading, data}) => {
    const dispatch = useDispatch()
    
    const { providers } = useSelector((state) => state.entities.billPayment)
    const [detailsOpen, setDetailsOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    const { AirtimeDataBillerIcon } = useBillPayments()
    
    
    const airtimeData = useTransformedBillers('airtime', providers?.response);
    
    
    
    const openTransactionDetail = (transaction) => {
        setSelected(transaction);
        setDetailsOpen(true);
    }
    
    
    
    useEffect(() => {
        dispatch(billPaymentAction.getProviders());
        // eslint-disable-next-line
    }, []);
    
    return (
        <div>
            
            <TransactionDetails 
                isOpen={detailsOpen}
                transaction={selected}
                setIsOpen={setDetailsOpen}
                AirtimeDataBillerIcon={AirtimeDataBillerIcon}
            />
            
            <div className="mt-6 box">
                
                <div className="flex items-center justify-start w-max">
                    <div className="font-medium">Airtime Purchase History&nbsp;</div>
                    
                    <div className="label h-6 text-sm font-normal text-ep-primary-600 bg-[#ecf2f2]">
                        <ContentLoading
                            loading={loading}
                            data={<>{data?.data?.totalDocs ?? "-"} {pluralize(data?.data?.totalDocs, "purchase", "purchases")}</>}
                        />
                    </div>
                </div>
                
                <div className="mt-6 flex flex-wrap justify-between">
                    <div className="max-w-sm flex-grow sm:mr-6">
                        <SearchBox placeholder="Search" name="search" extraUrlParams="page=1" />
                    </div>
                        
                    <div className="flex flex-wrap space-x-3 sm:space-x-3">
                        <div>
                            <Filter filters={[
                                {
                                    title: "Date range",
                                    name: "dateRange",
                                    dataType: "custom-timeframe",
                                    hasResetButton: true,
                                    options: [
                                        {
                                            display: "Today",
                                            payload: "today",
                                        },
                                        {
                                            display: "Last 7 days",
                                            payload: "7days",
                                        },
                                        {
                                            display: "30 days",
                                            payload: "30days",
                                        },
                                        {
                                            display: "1 Year",
                                            payload: "1year",
                                        },
                                    ],
                                },
                                {
                                    title: "Custom Date Range",
                                    dataType: "date-range",
                                    options: {
                                        from: {
                                            name: "startDate",
                                            placeholder: "Start Date",
                                        },
                                        to: {
                                            name: "endDate",
                                            placeholder: "End Date",
                                        },
                                    },
                                },
                                {
                                    title: "Biller",
                                    name: "biller",
                                    dataType: "select",
                                    options: airtimeData,
                                },
                                {
                                    title: "Transaction Status",
                                    name: "status",
                                    dataType: "select",
                                    options: [
                                        {
                                            display: "All",
                                            payload: "",
                                        },
                                        {
                                            display: "Successful",
                                            payload: "successful",
                                        },
                                        {
                                            display: "Pending",
                                            payload: "pending",
                                        },
                                        {
                                            display: "Failed",
                                            payload: "failed",
                                        },
                                    ],
                                },
                            ]}/>
                        </div>

                        <div>
                            <button type="button" onClick={togglePurchaseModal} className="btn btn-ep-primary rounded-lg flex items-center justify-center h-full">
                                <IconAdd width={15} className="mr-2"/>
                                <span>Purchase Airtime</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
                
            <div className="bg-white">

                <Table classTable="table-hover">
                    <Table.Head>
                        <th>Amount</th>
                        <th>Biller</th>
                        <th>Recipient</th>
                        <th>Date</th>
                        <th>Status</th>
                    </Table.Head>
                    <Table.Body>

                        <TableContent
                            loading={loading}
                            loadingText="Fetching Transactions"
                            data={data?.data?.transactions}
                            colspan={5}
                            emptyUI={
                                <TableEmptyData 
                                    actionButtonClicked={togglePurchaseModal}
                                    actionButtonText="Click here to purchase airtime"
                                />
                            }
                        />

                        {loading === false && data?.data?.transactions?.map((transaction) => {
                            const network = transaction?.product;
                            
                            return (
                                <tr key={transaction._id} onClick={() => openTransactionDetail(transaction)}>
                                    <td>
                                        {CurrencyFormat(transaction.amount / 100)}
                                    </td>
                                    <td>
                                        <AirtimeDataBillerIcon network={network} />
                                    </td>
                                    <td>
                                        {transaction?.account}
                                    </td>
                                    <td>
                                        <div>{DateFormat(transaction.createdAt)} at {TimeFormat(transaction.createdAt)}</div>
                                    </td>
                                    <td>
                                        <div className={"text-xs capitalize label " + renderStatusColor(transaction.status)}>
                                            {transaction.status}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        )}
                    </Table.Body>
                </Table>

                <Maybe condition={loading === false && data?.data?.transactions?.length > 0}>
                    <div className="mt-6">
                        <Pagination data={data?.data} />
                    </div>
                </Maybe>

            </div>
        </div>
    )
}


const TransactionDetails = ({transaction, setIsOpen, isOpen, AirtimeDataBillerIcon}) => {
    const transactionAmount = `-${CurrencyFormat(transaction?.amount / 100)}`

    return (
        <TransactionDetailsWrapper
            title="Debit"
            subtitle="Bill Payment - Airtime"
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            amount={transactionAmount}
            status={transaction?.status}
            noBottomRule={true}
            documentTitle={`Airtime purchase - ${DateFormat(transaction?.createdAt)}`}>
                <div className="w-full flex items-center justify-between text-sm mt-7">
                    <div className="text-ep-gray-500">Transaction Number</div>
                    <div className="text-ep-gray-700">
                        {transaction?.clientReference}
                    </div>
                </div>
                
                <div className="w-full flex items-center justify-between text-sm mt-7">
                    <div className="text-ep-gray-500">Time Stamp</div>
                    <div className="text-ep-gray-700">
                        {DateFormat(transaction?.createdAt)} at {TimeFormat(transaction?.createdAt)}
                    </div>
                </div>
                
                <div className="w-full flex items-center justify-between text-sm mt-7">
                    <div className="text-ep-gray-500">Recipient</div>
                    
                    <div className="flex items-center justify-center pt-1 text-ep-gray-700 bg-[#f9fafb] p-1.5 rounded-lg">
                        <div>{transaction?.account}</div>
                        {/* <span className='h-1 w-1 rounded-full bg-[#d1d5db] mx-1.5' />
                        <div className="capitalize">{transaction?.product}</div>
                        <span className='h-1 w-1 rounded-full bg-[#d1d5db] mx-1.5' />
                        <div>{CurrencyFormat(transaction?.amount / 100)}</div> */}
                    </div>
                </div>
                    
                <div className="w-full flex items-center justify-between text-sm mt-7">
                    <div className="text-ep-gray-500">Biller</div>
                    <div className="text-ep-gray-700">
                        <AirtimeDataBillerIcon network={transaction?.product} allUppercase={true} />
                    </div>
                </div>
                <div className="w-full flex items-center justify-between text-sm mt-7" style={{marginBottom: '40px'}}>
                    <div className="text-ep-gray-500">Narration</div>
                    <div className="text-ep-gray-500 ellipsis">
                        {transaction?.description}
                    </div>
                </div>
        </TransactionDetailsWrapper>
    )
}


export default AirtimeTransactionsTable;